export const getCurrentSpace = (key, spaceList) => {
  return spaceList.length ? spaceList.find((space) => space.key === key) : null;
};
